import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { constants } from 'helpers'
import { OVERLAY } from 'components/AuthModal/styles'

import CloseIcon from 'components/CloseIcon'
import { default as DefaultModal } from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import ProfileSelect from 'components/Profile/ProfileSelect'
import ProfileFormGroup from 'components/Profile/ProfileFormGroup'
import PrimaryButton from 'components/PrimaryButton'

const { H_NUMBERS, WAITLIST_STATUS, WAITLIST_STATUS_CONFIG } = constants

const DecisionModal = ({ show, waitlistStatus, onClose, onSave }) => {
  const [payload, setPayload] = useState({
    hNum: '',
    waitlistStatus,
  })

  useEffect(() => {
    setPayload(prevPayload => ({
      ...prevPayload,
      waitlistStatus,
    }))
  }, [waitlistStatus])

  const handleChange = useCallback(e => {
    const { name, value } = e.target
    if (value) {
      setPayload(prevPayload => ({ ...prevPayload, [name]: value }))
    }
  }, [])

  const actions = useMemo(
    () =>
      WAITLIST_STATUS_CONFIG[waitlistStatus]?.actions.map(action => ({
        label: WAITLIST_STATUS_CONFIG[action.toLowerCase()]?.state || action,
        value: action,
      })) || [],
    [waitlistStatus]
  )

  const handleSave = useCallback(() => {
    const validPayload = {}
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        validPayload[key] = payload[key]
      }
    })

    if (Object.keys(validPayload).length) {
      onSave(validPayload)
    }
  }, [payload, onSave])

  return (
    <Overlay
      show={show}
      className={OVERLAY}
      preventEscBackdropClose={true}
      onClose={() => onClose()}
    >
      <DefaultModal innerClassName="overflow-y-scroll flex flex-col justify-center px-5">
        <div className="relative h-auto flex flex-col items-center text-white w-full rounded-xl px-5 py-6 bg-woodsmokeBlackDarker md:w-96 ">
          <div className="w-full flex justify-end">
            <button
              className="bg-white bg-opacity-20 w-5 h-5 mb-2 rounded-full flex items-center justify-center"
              onClick={() => onClose()}
            >
              <CloseIcon className="w-2 h-2 text-white" />
            </button>
          </div>
          <div className="text-lg mb-8">Make a decison</div>
          {waitlistStatus === 'pre-approved' && (
            <div className="mb-4 flex">
              <div className="flex items-center mr-4">
                <span className="mr-2 text-white text-lg">H#</span>
                <select
                  value={payload.hNum}
                  onChange={handleChange}
                  name="hNum"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-100 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option>-</option>
                  {H_NUMBERS.map(v => (
                    <option value={v} key={v}>
                      {v}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          <ProfileFormGroup>
            <ProfileSelect
              name="waitlistStatus"
              value={payload.waitlistStatus}
              options={actions}
              onChange={handleChange}
            />
          </ProfileFormGroup>
          <PrimaryButton
            className="bg-azure w-full"
            disabled={
              !payload.waitlistStatus ||
              (payload.waitlistStatus === WAITLIST_STATUS.YES && !payload.hNum)
            }
            onClick={handleSave}
          >
            Save
          </PrimaryButton>
        </div>
      </DefaultModal>
    </Overlay>
  )
}

DecisionModal.propTypes = {
  show: PropTypes.bool,
  rewards: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default DecisionModal
